module.exports = __webpack_public_path__ + "img/ex-nim.586d2345.jpg";